import _isNil from "lodash/isNil";
import _trim from "lodash/trim";
import mapAtom from '../mapAtom';
import mapOperator from '../mapOperator';
export default (condition, items, solution) => {
  return condition.split(' and ').map(_trim).map(part => {
    const comparisonExpressionRegex = /([\w_()]*)\s*(==|>|<|!=)\s*([\w_()]*)/g;
    const atomResult = comparisonExpressionRegex.exec(part);
    if (_isNil(atomResult)) {
      throw new Error("Parsing failed for this atom ".concat(part));
    }
    const [, left, operator] = atomResult;
    let [,,, right] = atomResult;
    let rightContext = items;
    if (right === 'solution') {
      // copy the left atom, but execute it in the solution context
      right = left;
      rightContext = solution;
    }
    const {
      item,
      value: leftAtomValue
    } = mapAtom(left, items);
    const {
      value: rightAtomValue
    } = mapAtom(right, rightContext);
    return {
      item,
      result: mapOperator(operator)(leftAtomValue, rightAtomValue)
    };
  }).reduce((acc, _ref) => {
    let {
      item,
      result
    } = _ref;
    if (!_isNil(acc.item) && !_isNil(item) && acc.item !== item) {
      throw new Error("A condition should refer to only one item (".concat(acc.item.id, " and ").concat(item.id, " are used)"));
    }
    return {
      item: _isNil(item) ? acc.item : item,
      result: acc && result
    };
  }, {
    item: undefined,
    result: true
  });
};